<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >

    <b-row class="mx-0">
      <b-col
        md="8"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-50 mb-sm-0">
            Relatório de Acordos Semanais
          </h4>
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center mr-2">
              <span class="bullet bullet-voz svg-font-small-3 mr-50 cursor-pointer" />
              <span>Concluídos</span>
            </div>
            <div class="d-flex align-items-center">
              <span class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer" />
              <span>Cancelados</span>
            </div>
          </div>
        </div>

        <!-- chart -->
        <vue-apex-charts
          id="revenue-report-chart"
          type="bar"
          height="250"
          :options="revenueReport.chartOptions"
          :series="revenueReport.series"
        />
      </b-col>

      <b-col
        md="4"
        class="budget-wrapper d-flex flex-column align-items-center justify-content-center"
      >

        <h2 class="mb-25 text-center">
          {{ revenue_report.acordos_do_mes }} Acordos
        </h2>
        <div class="d-flex justify-content-center text-center">
          <span class="font-weight-bolder mr-25">Últimos 7 dias:</span>
          <span>{{ revenue_report.acordos_ultimos_7_dias }}</span>
        </div>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import axios from '@/../axios-auth'

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      revenue_report: {
        acordos_do_mes: 0,
        acordos_ultimos_7_dias: 0,
        acordos_concluidos: 0,
        acordos_cancelados: 0,
        acordos_em_andamento: 0,
        dias_semana: {
          segunda_feira: { acordos_cancelados: 0, acordos_concluidos: 0 },
          terca_feira: { acordos_cancelados: 0, acordos_concluidos: 0 },
          quarta_feira: { acordos_cancelados: 0, acordos_concluidos: 0 },
          quinta_feira: { acordos_cancelados: 0, acordos_concluidos: 0 },
          sexta_feira: { acordos_cancelados: 0, acordos_concluidos: 0 },
          sabado: { acordos_cancelados: 0, acordos_concluidos: 0 },
          domingo: { acordos_cancelados: 0, acordos_concluidos: 0 },
        },
      },
      revenueReport: {
        series: [
          {
            name: 'Concluídos',
            data: [],
          },
          {
            name: 'Cancelados',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            stacked: false, // Alteração importante: stacked para false
            type: 'bar',
            toolbar: { show: false },
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: { show: false },
            },
          },
          xaxis: {
            categories: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '0.86rem',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.voz, $themeColors.primary],
          plotOptions: {
            bar: {
              columnWidth: '35%',
              endingShape: 'rounded',
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '0.86rem',
              },
            },
          },
        },
      },

      // budget chart -  MANTIVE ESSE CHART COMO DEMONSTRAÇÃO, PODE REMOVER SE NÃO FOR USAR
      budgetChart: {
        options: {
          chart: {
            height: 80,
            toolbar: { show: false },
            zoom: { enabled: false },
            type: 'line',
            sparkline: { enabled: true },
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 5],
            width: [2],
          },
          colors: [$themeColors.primary, '#dcdae3'],
          tooltip: {
            enabled: false,
          },
        },
      },
    }
  },
  created() {
    axios.get('/api/v1/acordo/listar/chart_data').then(res => {
      this.revenue_report = res.data.dados // Ajuste para acessar .dados
      this.updateChartData()
    })
  },
  methods: {
    updateChartData() {
      const diasSemanaData = this.revenue_report.dias_semana
      const diasSemanaLabels = ['segunda_feira', 'terca_feira', 'quarta_feira', 'quinta_feira', 'sexta_feira', 'sabado', 'domingo']
      const acordosConcluidosData = []
      const acordosCanceladosData = []

      diasSemanaLabels.forEach(dia => {
        acordosConcluidosData.push(diasSemanaData[dia].acordos_concluidos)
        acordosCanceladosData.push(diasSemanaData[dia].acordos_cancelados)
      })

      this.revenueReport.series = [
        { name: 'Concluídos', data: acordosConcluidosData },
        { name: 'Cancelados', data: acordosCanceladosData },
      ]
    },
  },
}
</script>
